import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Proverava da li je dati link interni (počne sa `/`)
 * Funkcija sada pretpostavlja da je 'link' već validan string
 *
 * @param {string} link - URL link za proveru.
 * @returns {boolean} True ako je link interni, inače false
 */
const isInternalLink = (link) => {
    // Ova funkcija se sada fokusira samo na proveru da li link počinje sa '/'
    // Prethodna provera validnosti (null, undefined, prazan string) se radi direktno u SmartLink komponenti.
    return link.startsWith('/');
};

/**
 * SmartLink komponenta automatski bira između standardnog <a> taga i React Router <Link> komponente
 * na osnovu toga da li je URL interni (počinje sa '/') ili eksterni
 *
 * Ako je 'to' prop prazan string, null, ili undefined, komponenta će renderovati samo svoj 'children'
 * bez ikakvog link taga, sprečavajući neželjeno preusmeravanje
 *
 * @param {object} props - Props komponente.
 * @param {string} props.to - URL destinacija linka (interna putanja ili eksterni URL).
 * @param {React.ReactNode} props.children - Sadržaj koji će biti unutar linka
 * @param {string} [props.className] - CSS klasa koja se primenjuje na link
 * @param {object} [props.rest] - Svi ostali prosleđeni props (npr. onClick, id, itd.) biće prosleđeni baznom elementu
 */
const SmartLink = ({ to, children, className, isNewTabOpen, ...rest }) => {
    // **Ključna promena:** Proveravamo validnost 'to' propa na samom početku.
    // Link je validan ako postoji, tipa je string, i nije prazan nakon trimovanja.
    // const hasValidLink = to && typeof to === 'string' && to.trim() !== '';
    const hasValidLink = to &&
        typeof to === 'string' &&
        to.trim() !== '' &&
        to.trim() !== '/' && // Ignorišemo link ('/') koji vodi na početnu stranicu (izbaciti ovu liniju ako želimo da '/' bude validan link)
        !to.trim().toLowerCase().includes('undefined');

    if (!hasValidLink) {
        // Ako link nije validan (null, undefined, ili prazan string),
        // renderujemo samo sadržaj (children) bez ikakvog link tag-a
        // Ni 'className' ni 'rest' propovi neće biti primenjeni, jer nema omotača
        return children;
    }

    // Pozivamo isInternalLink da odredimo tip
    const isInternal = isInternalLink(to);

    // Ako je isNewTabOpen = 1, dodajemo target="_blank"
    const newTabProps = isNewTabOpen ? { target: '_blank', rel: 'noopener noreferrer' } : {};


    if (isInternal) {
        // Ako je link interni (počinje sa '/'), renderuje React Router <Link> komponentu
        return (
            <Link to={to} className={className} {...newTabProps} {...rest}>
                {children}
            </Link>
        );
    } else {
        // Ako link NIJE interni (ne počinje sa '/'), renderuje standardni <a> tag
        // Ovo obuhvata sve http://, https://, www., ili čak samo "example.com"
        return (
            <a href={to} className={className} {...newTabProps} {...rest}>
                {children}
            </a>
        );
    }
};

export default SmartLink;
